enum CatalogMode {
  default = 1,
  groupingService = 2,
}

export { CatalogMode };
